(function Module() {
	'use strict';

	var Chart	= require('chart.js');

	mySynch.controller('FertilityAnalysisDashboardController', [
		'$scope',
		'$window',
        'MySynchFactory',
		'ViewAuthorizationFactory',
        'mySynchEnumerationService',
		'ApiFactory',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		'$q',
		function FertilityAnalysisDashboardController($s, $w, MSF,viewAuth,mySynchEnumSvc, api, perfMetricSvc, perfContextSvc, log, $q) {
			var self                	= this;
			self.performanceContext		= null;
			self.loading            	= true;
			self.dataUpdatedDate    	= null;
			self.bredSumHistory			= [];
			self.filteredDataSet		= [];
			self.filteredJournalDataSet	= [];
			self.ymd 					= 'YYYY-MM-DD';				// Used for ordering
			self.isMobile				= true;
			self.dateFormat             = "";

			self.hasUpdatePermission = false;
            self.updatePermissionCode = 'FERTILITY_ANALYSIS_UPDATE';
			self.hasJournalUpdatePermission = false;
			self.journalUpdatePermissionCode = 'JOURNAL_UPDATE';


			self.disabledLactDropdown	= true;

			self.tooltipDate = '';

			// --- Chart line colors ---
			self.inseminationLineColor	= _.find(MSF.colorComponents, {name: 'insemination'}	).fillColor;
			self.conceptionLineColor	= _.find(MSF.colorComponents, {name: 'conception'}		).fillColor;
			self.pregnancyLineColor		= _.find(MSF.colorComponents, {name: 'pregnancy'}		).fillColor;
			self.pregnancyRhaLineColor	= _.find(MSF.colorComponents, {name: 'pregnancyRha'}	).fillColor;
			// --- Chart gridline colors ---
			self.base 					= 'rgba(180,180,180, 0.9)';
			self.lighter				= 'rgba(210,210,210, 0.5)';

			// --- Chart journal flag/note colors ---
			self.journalFlagColor		= 'rgba(78,78,78, 0.9)';
			self.journalHoverflagColor	= 'rgba(36,47,255, 0.9)';
			self.noteIcon				= new Array(10);
			self.noteHoverIcon			= new Array(10);

			createJournalNoteIcons();
			function createJournalNoteIcons() {
				for (var i1 = 0; i1 <= 9; i1++) {
					self.noteIcon[i1]			= new Image();
					self.noteIcon[i1].src		= '/img/journal-icons/NoteGray'+i1+'.png';
					self.noteHoverIcon[i1]		= new Image();
					self.noteHoverIcon[i1].src	= '/img/journal-icons/NoteBlue'+i1+'.png';
					// -- resize images
					self.noteIcon[i1].style.width  = '20%';
					self.noteIcon[i1].style.height = 'auto';
				}
			}

			// --- Dropdown Lists ---
			self.journalCategories		= MSF.lists.journalCategory;
			self.dateRanges				= [
				{name: 'Last 12 months', code: 12, monthsPerLabelDesktop: 1, monthsPerLabelMobile: 3 },
				{name: 'Last 24 months', code: 24, monthsPerLabelDesktop: 2, monthsPerLabelMobile: 6 }
			];
			self.lactations				= [
				{name: 'All Lactations', 			code: 3, display: 'All'},
				{name: '1st Lactation',	code: 1, display: '1'  },
				{name: 'Lactation 2+',	code: 2, display: '2+' }
			];
			self.fertilityRates			= [
				{name: 'All', 			code: 0},
				{name: 'Insemination',	code: 1},
				{name: 'Conception',	code: 2},
				{name: 'Pregnancy',		code: 3},
				{name: 'Pregnancy RHA',	code: 4}
			];
			self.current = {
				dateRange:		'',
				lactation:		'',
				fertilityRate:	''
			};

			// --- Dropdown Defaults ---
			self.filters = {
				dateRange:		12,
				lactation:		3,
				fertilityRate:	0
			};
			self.dateRange				= self.filters.dateRange;
			self.lactation				= self.filters.lactation;
			self.fertilityRate			= self.filters.fertilityRate;
			self.current.dateRange		= getCurrentFilterLabel('dateRange');
			self.current.lactation		= getCurrentFilterLabel('lactation');
			self.current.fertilityRate	= getCurrentFilterLabel('fertilityRate');
			self.chartInstance			= null;


			// event deregister functions
			var deregOnHerdChange = null;

			self.showAddNewJournalEntry = function showAddNewJournalEntry() {
				MSF.loadPage('NewJournal', {cameFrom: 'FertilityAnalysis'});
			};
			self.showViewEditJournalEntry = function showViewEditJournalEntry(row) {
				MSF.loadPage('JournalEdit', {id: row.id, cameFrom: 'FertilityAnalysis'});
			};

			function disableThis() {
				return true;
			}
			self.disableThis = disableThis();

			self.getCategoryName = function getCategoryName(value) {
				return (_.find(self.journalCategories, {code: value}).description);
			};

			function getCurrentFilterLabel(dropdown) {
				var label = '';

				if 		(dropdown == 'dateRange') 		{ label = _.find(self.dateRanges, { code: self.dateRange }).name; 	 }
				else if (dropdown == 'lactation') 		{ label = _.find(self.lactations, { code: self.lactation }).display; }
				else if (dropdown == 'fertilityRate') 	{ label = self.fertilityRate; }	

				$s.months24 = (self.dateRanges.code == 24);
				return label;
			}
			self.twoYearsSelected = function() {
				return $s.months24;
			};

			function filterDataset() {
				var dt = moment(MSF.activeHerd.latestReportDate).subtract(self.dateRange, 'months').startOf('month');
				var withinDateRange = _
					.chain(self.bredSumHistory)
					.filter(o => (moment(o.localDate) >= dt))
					.filter(o => (o.lactation == self.lactation))
					.value();

				self.filteredDataSet = _.filter(withinDateRange);

				return self.filteredDataSet;
			}

			self.jeIconName = function(slot) {
				var output = '/img/journal-icons/' + filteredDataSet[slot].journalNoteCnt + '/.png';
				return output;
			};
			self.showTheseJEs = function (jrnlNotes) {
				if ($s.showingJEs && 
					self.newFilteredJournal === jrnlNotes) {
					return self.toggleShowJEs();
				}
				$s.showingJEs = true;
				self.newFilteredJournal = jrnlNotes;

				if (jrnlNotes.length == 0) {
					self.toggleShowJEs();
				}
			};

			$s.showingJEs = false;
			self.showJEs = function () {
				$s.showingJEs = true;
			};
			self.toggleShowJEs = function () {
				$s.showingJEs = !$s.showingJEs;
			};

			self.closeJEs = function () {
				self.newFilteredJournal = [];
				$s.showingJEs = !$s.showingJEs;
			};

			
			self.filterNewJournalDataset = function filtered(selectedDate) {
				var stDate = moment(new Date(selectedDate));
				var enDate = moment(new Date(stDate)).add(21, 'days');

				var withinDateRange = _
					.chain(self.journalItems)
					.filter(o => (moment(o.date) >= stDate && moment(o.date) <= enDate))
					.value();

				var output = _.filter(withinDateRange);
				return output;
			};

			function filterJournalDataset(insertJournalsIntoFilteredDataSetToo) {
				var dt = moment(MSF.activeHerd.latestReportDate).subtract(self.dateRange, 'months').startOf('month');
				var withinDateRange = _
					.chain(self.journalItems)
					.filter(o => (moment(o.localDate) >= dt))
					.value();

				self.filteredJournalDataSet = _.filter(withinDateRange);

				if (insertJournalsIntoFilteredDataSetToo) {
					self.totalCnt = 0;

					// -- clear out journals from bredSumHistory chart data
					_.forEach(self.filteredDataSet, function formatted(o) {
						o.journal0			= 0;
						o.journalFlag		= new Image(self.noteIcon[0]);
						o.journalNotes		= [];
						o.journalNoteCnt	= 0;
					});

					// -- Load bredSumHistory's chart data with inline counts of journal notes
					var jeLen = _.size(self.filteredJournalDataSet);
					var faLen = _.size(self.filteredDataSet);

					for (var je1 = 0; je1 < jeLen; je1++) {
						faLen  = _.size(self.filteredDataSet);
						for (var fa2 = 0; fa2 < faLen; fa2++) {
							var stDate = moment(new Date(self.filteredDataSet[fa2].date));
							var enDate = moment(new Date(stDate)).add(21, 'days');
							var jeDate = moment(new Date(self.filteredJournalDataSet[je1].date));
							if ((jeDate >= stDate  &&
								 jeDate <  enDate) ||
								// -- if last cycle, include all remaining Journals
								(jeDate >= stDate  && 
								 fa2    == faLen-1) )	{
									var num = 0;
									self.filteredDataSet[fa2].journalNotes.splice(fa2, 0, self.filteredJournalDataSet[je1]);
									self.filteredDataSet[fa2].journal0	 	+= 0.0001;		// TODO: make this only add 1 integer for live (0.0001 for test)
									num = self.filteredDataSet[fa2].journalNoteCnt++;
									self.totalCnt++;
									if (num >= 0 && num < 9) {	
										self.filteredDataSet[fa2].journalFlag = self.noteIcon[num+1];
									}
									else if (num > 9) {
										self.filteredDataSet[fa2].journalFlag = self.noteIcon[9];
									}
									// -- resize image
									self.filteredDataSet[fa2].journalFlag.width  = 24;
									self.filteredDataSet[fa2].journalFlag.height = 24;

									break;
							}
						}
					}
				}

				return self.filteredJournalDataSet;
			}

			function updateDataGrid() {
				self.filteredGridData 		 = filterDataset();
				self.filteredJournalGridData = filterJournalDataset();
			}

			var chart;
			function resizeJeNoteBar() {
				var chartW = self.chartInstance.width;
				$s.chartWidth = chartW;
			}
            function updateChart() {
				if (chart) {
					chart.destroy();
				}

				//#region Chart
				self.chartInstance = $('#fertilityanalysis-chart')[0];
				
				$w.addEventListener("resize", resizeJeNoteBar);

				

				self.glueJeNoteBarToChart = function () {
					$s.chartWidth = ($s.chartWidth ? true : $s.chartWidth, 1222);
					return $s.chartWidth;
				};



				self.periodDates = _.chain(self.filteredDataSet)
									.pluck('localDate')
									.uniq()
									.value();

				var tmpDates = [];
				for (var cnt = 0; cnt < self.periodDates.length; cnt++) {
					tmpDates.push(moment(new Date(self.periodDates[cnt])).startOf('month').format(self.ymd));
				}

				// Additional 1st of month add, as it might be needed
				tmpDates.sort().push(moment(new Date(tmpDates[_.size(tmpDates)-1])).add(1,'months').format(self.ymd));

				self.periodDates = _.chain(tmpDates).uniq().value();

				function setToolTipDataPointDates() {
					var output	= _.map(filterDataset(), 'localDate');
					return (output);
				}

				var lineWidth			= 2;

				var inseminationColor	= self.inseminationLineColor,
					conceptionColor		= self.conceptionLineColor,
					pregnancyColor		= self.pregnancyLineColor,
					pregnancyRhaColor	= self.pregnancyRhaLineColor;

				function createDateLabel() {
					var dt = moment(MSF.activeHerd.latestReportDate).subtract(self.dateRange, 'months').startOf('month');
					var baseDates = _
									.chain(self.filteredDataSet)
									.filter(o => (moment(o.localDate) >= dt))
									.filter(o => (o.lactation == self.lactation))
									.pluck('localDate')
									.uniq()
									.value();

					var tmpDates = _.forEach(baseDates, function formatted(o) { return moment(o.localDate).format('YYYY MMM'); });
					
					var output = _.chain(tmpDates).uniq().value().sort();//.reverse();
					return output;
				}

				// --- fertility analysis data to display ---
				var dataToDisplay	= filterDataset()

				var insemDataToDisplay		= _.map(dataToDisplay, 'insemRate' )
				var concepDataToDisplay		= _.map(dataToDisplay, 'concepRate')
				var pregDataToDisplay		= _.map(dataToDisplay, 'pregRate'  )
				var pregRhaDataToDisplay	= _.map(dataToDisplay, 'rhaPreg'   )

				// -- clear null out final 2 rates, so graph doesn't spike to zero
				for (var i1 = 0; i1 < 2; i1++) {
					if (insemDataToDisplay[i1]  == 0) 	{ insemDataToDisplay[i1] 	= null; }
					if (concepDataToDisplay[i1] == 0) 	{ concepDataToDisplay[i1] 	= null; }
					if (pregDataToDisplay[i1] 	== 0) 	{ pregDataToDisplay[i1] 	= null; }
				}

				// --- journal data to display
				self.journalDataToDisplay	 = filterJournalDataset(true)
				self.newJournalDataToDisplay = self.filteredJournalDataSet;

				var journalZeroLineToDisplay = _.map(self.filteredDataSet, 'journal0'		)
				self.journalFlagsToDisplay	 = _.map(self.filteredDataSet, 'journalFlag'	)

				// --- Hints and dates on x-axis to display
				var tooltipDateToDisplay	= setToolTipDataPointDates();
				var labelDateToDisplay		= createDateLabel();
				self.labels 				= labelDateToDisplay;

				var data	= {
					labels: self.labels,
					datasets: [{			// -- dataset 0 --- Insemination Line
						data:				insemDataToDisplay,
						borderColor:		inseminationColor,
						fill: 				false,
						borderWidth:		lineWidth,
						hidden:				(self.fertilityRate !== 0 && self.fertilityRate !== 1),
					},{						// -- dataset 1 --- Conception Line
						data: 				concepDataToDisplay,
						borderColor: 		conceptionColor,
						fill: 				false,
						borderWidth:		lineWidth,
						hidden:				(self.fertilityRate !== 0 && self.fertilityRate !== 2),
					},{						// -- dataset 2 --- Pregancy Line
						data: 				pregDataToDisplay,
						borderColor:		pregnancyColor,
						fill: 				false,
						borderWidth:		lineWidth,
						hidden:				(self.fertilityRate !== 0 && self.fertilityRate !== 3),
					},{						// -- dataset 3 --- Rolling Herd Average Pregnancy Rate Line
						data: 				pregRhaDataToDisplay,
						borderColor:		pregnancyRhaColor,
						fill: 				false,
						borderWidth:		lineWidth,
						hidden:				(self.fertilityRate !== 0 && self.fertilityRate !== 4),
					},{						// -- dataset 4 --- Tooltop details
						data: 				tooltipDateToDisplay,
						borderColor:		pregnancyRhaColor,
						fill: 				false,
						borderWidth:		0,

					},{						// -- dataset 5 --- Journal Count (0.0001 = 1) for Icons on Zero Line of Chart
						data: 				journalZeroLineToDisplay, 
						borderColor: 		self.journalFlagColor,
						fill: 				false,
						borderWidth:		0,
						pointStyle:			[],

						pointRadius:		0.01,
						hoverRadius:		0.01,
						hoverBorderWidth:	0.02,
					}]
				};

				var options = {
					responsive:				true,
					maintainAspectRatio:	false,		// this will grow taller exponentially when set to 'false', UNLESS the height is set in parent container (see .override-height)
					layout: { padding: {	bottom: 	20 } },
					legend: {				display: false },
					hover: {
						onHover: function (evt, item) {
							if (/* item.length && */ evt.type == 'click') {
								self.closeJEs();
							}
						}
					},
					elements: {
						line: 	{			tension:  	0.125 },
						point:	{			radius: 			0.001,
											hitRadius:			18,
											hoverRadius:		0,
											hoverBorderWidth:	0.01 },
					},
					scales: {
						yAxes: [{
							stacked: false,
							ticks: 		{	beginAtZero: 	true,
											min: 			0,
											max:			100,
											stepSize:		5,
											callback: function addUnitsToLabel(value, index) {
												var theTick = value + '%  ';
												if (value % 5 === 0) {
													theTick = '';
												}
												if (/*self.isMobile &&*/ value % 10 === 0) {
													theTick = value + '%  ';
												}
												return theTick;
											},
									},
							gridLines:	{	drawTicks:   	false,
											zeroLineWidth:	0,
											tickMarkLength: 5,
											color:			[self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															 self.base, self.lighter,
															],
							}
						}],
						xAxes: [{
							type: 		'time',
							time: 	{ 	unit:
											'month',
										displayFormats: { 
											'millisecond':	'MMM YYYY',
											'second':		'MMM YYYY',
											'minute':		'MMM YYYY',
											'hour':			'MMM YYYY',
											'day':			'MMM YYYY',
											'week':			'MMM YYYY',
											'month':		'MMM YYYY',
											'quarter':		'MMM YYYY',
											'year':			'MMM YYYY'
									}
							},
							stacked:			false,
							displayFormat:		true,

							distribution:		'linear',
							bounds:				'data',

							ticks:		{
								beginAtZero:	true,
								display:		true,
								source:			'auto',
								//lineHeight:		1.0,
								labelOffset:	20,
								count:			3,			// 4 w/b good for Mobile
								minRotation:	0,
								maxRotation:	0
							},
							gridLines:	{
								show: 						false,
								drawTicks:					true,
								drawOnChartArea:			false,
								zeroLineWidth:				1,
								tickMarkLength: 			12,
								lineHeight:					25
							}
						}]
					},
					tooltips: {
						titleFontSize:		 0,//15,
						titleSpacing:		 3,
						titleMarginBottom:	 0,//15,
						bodyFontSize:		13,
						bodySpacing:		 4,
						callbacks: {
							intersect: false,
							events: ['click'],  //,'mousemove','touchmove'],
							label: 		function removeTooltipLabel(item, chart) { },
							afterBody: 	function afterBody(item, chart) {
								var lines = [];

								if (_.isArray(item) && item.length > 0) {
									var thisItem = item[0];
									var data1 = chart.datasets[0].data[thisItem.index];
									var data2 = chart.datasets[1].data[thisItem.index];
									var data3 = chart.datasets[2].data[thisItem.index];
									var data4 = chart.datasets[3].data[thisItem.index];
									var data5 = chart.datasets[4].data[thisItem.index];
									var flags = chart.datasets[4];

									self.tooltipDate = moment(data5).format(self.dateFormat);

									lines.push(self.tooltipDate);
									lines.push('');
									lines.push('Insemination Risk:     ' + (data1 === null ? '-': data1 + '%'));
									lines.push('Conception Risk:       ' + (data2 === null ? '-': data2 + '%'));
									lines.push('Pregnancy Risk:        ' + (data3 === null ? '-': data3 + '%'));
									lines.push('Pregnancy RHA:        '  + (data4 === null ? '-': data4.toFixed(1) + '%'));

								}

								return lines;
							}
						}
					}
				};
				//#endregion Chart Setup Data

				chart = new Chart(self.chartInstance, {
					type: 	'line',
					data: 	 data,
					options: options,
				});

				$s.chartWidth = chart.width;

			}

			function formattedPercent(rate, decimals=0) {
                if (rate == null || rate == 0) {
					return '-'; }

				decimals = _.isNumber(decimals) ? decimals : 0;
				return	   _.isNumber(rate)     ? rate.toFixed(decimals).toString() : '';
			}

			function bredSumHistoryRows(lineItems) {
                var date		= _.get(lineItems, 'date');
                var lactation		= _.get(lineItems, 'lactation', 	0);
                var bredEligCount	= _.get(lineItems, 'bredEligCount', 0);
                var bredCount		= _.get(lineItems, 'bredCount',		0);
                var insemRate		= _.get(lineItems, 'insemRate',		0);
                var concepRate		= _.get(lineItems, 'concepRate',	0);
				var pregCount       = _.get(lineItems, 'pregCount',	0);
				var pregEligCount   = _.get(lineItems, 'pregEligCount',	0);
                var pregRate        = _.get(lineItems, 'pregRate',		0);
                var rhaPreg			= _.get(lineItems, 'rhaPreg',		0);
                var localDate		= moment(date).subtract(moment(date).utcOffset(), 'minutes');
				var localEndDate	= moment(localDate).add(20,'days');
				var abortsCount     = _.get(lineItems, 'abortsCount',    0);      

				return {
					date:			moment(date).toDate(),
					lactation:		lactation,
					bredEligCount:	bredEligCount,
					bredCount:		bredCount,
					bredEligRatioFmt: bredCount.toString()+" / "+bredEligCount.toString(),
					insemRate:		insemRate,
					concepRate:		concepRate,
					insemRateFmt:	(!_.isUndefined(insemRate) && !_.isNull(insemRate) && _.isNumber(insemRate)) ? formattedPercent(insemRate) : "",
					concepRateFmt:	formattedPercent(concepRate),
					pregRateFmt:	(!_.isUndefined(pregRate) && !_.isNull(pregRate) && _.isNumber(pregRate)) ? formattedPercent(pregRate) : "",
					rhaPregFmt:		formattedPercent(rhaPreg, 1),
					pregCount:      pregCount,
					pregEligCount:  pregEligCount,
					pregEligRatioFmt: pregCount.toString()+" / "+pregEligCount.toString(),
					pregRate:		pregRate,
					rhaPreg:		rhaPreg,
					journalNotes:	[],
					journalNoteCnt: 0,
					journal0:		0,
					localDate:	localDate.format(self.ymd),
					localEndDate:	localEndDate,
					dateRangeFmt:   localDate.format(self.dateFormat)+" - "+localEndDate.format(self.dateFormat),
					displayDate:	localDate.format(self.dateFormat),
					abortsCount: 	abortsCount
				};
			}

			function journalRows(lineItems) {
                var id				= _.get(lineItems, 'id');
                var herdId			= _.get(lineItems, 'herdId');
                var date			= _.get(lineItems, 'date');
                var category		= _.get(lineItems, 'category');
                var categoryName	= _.find(MSF.lists.journalCategory, {code: category}).name;
                var description		= _.get(lineItems, 'description', '');
                var localDate		= moment(date).subtract(moment(date).utcOffset(), 'minutes');

				return {
                	id:				id,
                	herdId:			herdId,
					date:			date,
					category:		category,
					categoryName:	categoryName,
					description:	description,
					count:			1 * 0.0001,					// TODO: gather counts per period, or same date, or something
					localDate:	localDate.format(self.ymd),
					displayDate:	localDate.format(self.dateFormat),
					displayDateYY:	localDate.format(self.dateFormat) // had only YY in original code
				};
			}

            function loadReportData() {
				var loadPagePromise = $q.defer();
				self.loading                = true;
				self.lineItems              = [];
				self.noDataOrErroneousData  = false;
				self.incompleteSetupMessage = '';

				self.fertilityData = [];
				self.journalData   = [];

				var herdId = MSF.getActiveHerd().herdId;

				perfMetricSvc.startTiming("Page:FertilityAnalysisDashboardPageData:Request")
				async.auto({
					getBredSumHistory: function getBredSumHistory(done) {
						api.getFertilityAnalysisByHerd(herdId, self.performanceContext, 
							function gotFertilityData(err, data) {
								if (err) {
									log.error({error: err}, 'Error getting fertility analysis / bredsumhistory data');
								}
								self.fertilityData	= data;

								return done(err, data);
						});
					}, 

					getJournal: function getJournal(done) {
						api.getJournalByHerd(herdId, self.performanceContext, 
							function gotJournalData(err, data) {
								if (err) {
									log.error({error: err}, 'Error getting journal data');
								}
								self.journalData	= data;

								return done(err, data);
						});
					}

				}, function gotBredSumHistoryAndJournalData(err, data) {
					    perfMetricSvc.endTiming("page","Page:FertilityAnalysisDashboardPageData:Request", self.performanceContext);
						//#region inner Gotfunction

						perfMetricSvc.startTiming("Page:FertilityAnalysisDashboard:Build");
						$s.$evalAsync(function gotBredSumHistoryAndJournalDataWithApply() { // use $scope.$evalAsync here because $http callbacks have already been executed above so we need a digest for this code.
							if (err) {
								self.loading		= false;

								var errorData = data.getBredSumHistory;

								MSF.notify.danger('Unable to load bredsumhistory');
								if (errorData.statusCode === 403) { // 403 indicates setup is not complete and should have display message in response
									self.incompleteSetupMessage = errorData.statusText;
								}

								return;
							}
						});

						// --- Prep Data to Display ---
						
						self.bredSumHistory			= _.sortByOrder(
													_.map(self.fertilityData,	bredSumHistoryRows),  ['date'], ['asc']);
						self.filteredGridData		= _.sortByOrder(
													_.map(self.fertilityData,	bredSumHistoryRows), ['date'], ['asc']);
						self.journalItems			= _.sortByOrder(
													_.map(self.journalData,	journalRows),		 'localDate', 'DESC');
						self.filteredJournalGridData= _.sortByOrder(
													_.map(self.journalData,	journalRows),		 'localDate', 'DESC');
						self.newFilteredJournal 	= [];

						updateDataGrid();
						self.loading		= false;

						updateChart();

						if (_.size(self.bredSumHistory) <= 0) {
							log.info('There is no fertility analysis data to display');
						}
						perfMetricSvc.endTiming("page","Page:FertilityAnalysisDashboard:Build", self.performanceContext);
						loadPagePromise.resolve(true);
						//#endregion inner Gotfunction
					}

				);
				return loadPagePromise.promise;
			}

			function cleanupChart(){
				if(!chart){
					console.warn('Could not cleanup chart, chart is not defined');
					return;
				}
				try {
					// Kill hidden resize monitor div
					const monitor = chart.canvas?.parentNode?.querySelector('.chartjs-size-monitor');
					monitor?.remove();

					// Destroy Chart instance and internal bindings
					chart.destroy();

					// Remove DOM canvas node
					chart.canvas?.remove();

					// Null all Chart object references
					chart.canvas = null;
					chart.ctx = null;
					chart.config = null;
					chart.scales = null;
					chart.$context = null;
					if (chart.chartArea) {
						chart.chartArea = null;
					}
					self.chartInstance = null;
					

					// Remove any Chart.js attached event listeners on the window
					$w.removeEventListener("resize", resizeJeNoteBar);
				} catch (e) {
					console.warn('Error cleaning up chart: ', e);
				}

				// Remove any jQuery-bound handlers (if any were used)
        		$('fertility-cohort-trend-chart').off();
			}

			$s.$on("$destroy", function() {
				if (deregOnHerdChange) {
					deregOnHerdChange();
				}
				cleanupChart();
				$w.removeEventListener("resize", resizeJeNoteBar);
				self.performanceContext = null;
			});

			MSF.ready(function onMsfReady() {
				self.hasUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',self.updatePermissionCode));
				self.hasJournalUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',self.journalUpdatePermissionCode));
             
				var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
				var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
				self.dateFormat = MSF.getActiveHerdTimeFormatWithLongDigitYear();
                self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? MSF.getFormattedLongDateString(metaLastEventDateString) : '';

				self.performanceContext =  perfContextSvc.createPerformanceContext(currentActiveHerdId);
				perfMetricSvc.startTiming("Page:FertilityAnalysisDashboard:Render");
				loadReportData().then((result)=> {
					perfMetricSvc.markPageReady("Page:FertilityAnalysisDashboard:Render", self.performanceContext);
				});
			});

			deregOnHerdChange = $s.$on('herd:changed', function herdChanged() {
				self.hasUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',self.updatePermissionCode));
				self.hasJournalUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',self.journalUpdatePermissionCode));
				
				var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
				var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
				self.dateFormat = MSF.getActiveHerdTimeFormatWithLongDigitYear();
                self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? MSF.getFormattedLongDateString(metaLastEventDateString) : '';

				self.performanceContext =  perfContextSvc.createPerformanceContext(currentActiveHerdId);
				perfMetricSvc.startTiming("Page:FertilityAnalysisDashboard:RenderOnHerdChange");
				loadReportData().then((result)=> {
					perfMetricSvc.markPageReady("Page:FertilityAnalysisDashboard:RenderOnHerdChange", self.performanceContext);
				});
			});

			self.changeAnyFilter = function() {
				self.filters.dateRange		= dateRange;
				self.filters.lactation		= lactation;
				self.filters.fertilityRate	= fertilityRate;
				self.current.dateRange		= getCurrentFilterLabel('dateRange');
				self.current.lactation		= getCurrentFilterLabel('lactation');
				self.current.fertilityRate	= getCurrentFilterLabel('fertilityRate');

				updateChart();
				updateDataGrid();
			};

			// Code supporting the display of reasons for 403 when viewing dashboard
			self.incompleteSetupMessage = '';
			self.setupIsIncomplete 		= function setupIsIncomplete() {
				return self.incompleteSetupMessage !== '';
			};
			self.getIncompleteSetupMessages = function getIncompleteSetupMessages() {
				return self.incompleteSetupMessage.split('|');
			};

			$s.isMobile						= self.isMobile;
			// Add these to the scope so they are visible to the mixin
			$s.setupIsIncomplete			= self.setupIsIncomplete;
			$s.getIncompleteSetupMessages	= self.getIncompleteSetupMessages;
		}
	]);
})();